const zh_CN = {
  profile: '个人信息',
  logout: '退出',
  docs: '文档',
};
export default zh_CN;
